export default __webpack_public_path__ + "static/media/LB.0ca8698b.svg";